module.exports = {
  __depends__: [
    require(5),
    require(10)
  ]
};